export default __webpack_public_path__ + "static/media/img-0272-malta-full-face.25e62e6c.png";